import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
} from "@angular/core";

import { InviteListConfig, User } from "../../../../models";

@Component({
  selector: "invite-alerts-modal",
  templateUrl: "./invite-alerts-modal.component.html",
  styleUrls: [
    "./invite-alerts-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class InviteAlertsModal implements OnInit {
  // list component inputs
  @Input() limit: number;
  @Input() config: InviteListConfig;
  @Input() currentUser: User;
  @Output() confirmAlert = new EventEmitter<any>();

  // modal inputs
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public alertUser(event) {
    this.confirmAlert.emit(event);
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
